module.exports = __webpack_public_path__ + "img/passport-fin-new.c2b40478.png";